export const state = {
  credentials: {
    email: undefined,
    password: undefined
  }
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/signIn/state.js